import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyVehicle = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/vehicles',

        branches: [],
        branchesLoading: false,

        vehicleTypes: [],
        vehicleTypesLoading: false,
        vehicleTypeLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches,
        
        vehicleTypes: state => state.vehicleTypes,
    },
};
